import React from 'react';

import './tabbar.css';


/*
 * ---------------------------------------------------------------------
 * TabContent
 * ---------------------------------------------------------------------
 * stateless component
 *
 * basic Tab Content container
 * as an additional helper container for Material UI Tabs
 * which adds the padding to the tabs
 */
function TabContent (props) {
    let cssClass = "tab-content-container"
    if( props.className )
        cssClass = cssClass + " " + props.className;

    return (<div className={cssClass}>
                { props.children }
            </div>);
}

/*
* ---------------------------------------------------------------------
* Export
* ---------------------------------------------------------------------
*/
export default TabContent;
